import styled from "styled-components";
import { media } from "../../../theme";

/**
 * FORM SATIRI ve SÜTUNU — panelin bütün çok sütunlu form düzenleri için.
 *
 * NEDEN VAR: aynı düzen üç ayrı biçimde kopyalanıyordu —
 *   1. `<Flex gap={50}>` + iki `<Flex flex={1} direction="column">`
 *   2. yan yana iki `<TextInput w="50%">`
 *   3. `<Flex w="50%" direction="column">`
 * Üçü de dar ekranda aynı şekilde bozuluyordu ve düzeltmesi her dosyada ayrı
 * yazılacaktı. Tek yerde toplanınca kural bir kere yazılıyor, bundan sonra
 * açılan form da kendiliğinden uyumlu geliyor.
 *
 * Kullanım:
 *   <FormRow>            iki alan yan yana, ≤768'de alt alta
 *     <TextInput ... />  (doğrudan alan)
 *   </FormRow>
 *
 *   <FormRow $gap={50}>          iki sütunluk uzun form
 *     <FormColumn>...</FormColumn>
 *     <FormColumn>...</FormColumn>
 *   </FormRow>
 *
 *   <FormRow $half>      masaüstünde yarım genişlik, ≤1024'te tam
 */
export const FormRow = styled.div<{ $gap?: number; $half?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${(p) => p.$gap ?? 20}px;
  width: ${(p) => (p.$half ? "50%" : "100%")};

  /*
   * Çocuklar eşit paylaşır. Satır içi w=50% gibi genişlikler bu sayede
   * gereksizleşiyor; min-width: 0 olmadan da uzun etiketli bir alan satırı
   * şişiriyordu.
   */
  > * {
    flex: 1;
    min-width: 0;
  }

  /* Yarım genişlikli satır dar tablette zaten dar; tam genişliğe çıksın. */
  ${media.compact} {
    width: 100%;
  }

  ${media.mobile} {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
`;

/** Satırın bir bacağı: içindeki alanlar alt alta dizilir. */
export const FormColumn = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.$gap ?? 5}px;
  flex: 1;
  min-width: 0;
`;

/**
 * Masaüstünde yarım genişlikli tek sütun (kısa formlar: kontrat, departman).
 * ≤1024'te tam genişliğe çıkar — dar tablette yarım sütun okunmuyordu.
 */
export const FormColumnHalf = styled(FormColumn)`
  width: 50%;
  flex: none;
  gap: 20px;

  ${media.compact} {
    width: 100%;
  }
`;

/**
 * TEK SÜTUNLU DAR FORM (yeni tablet, panel kullanıcısı, etiket).
 *
 * Bu formlar sabit genişlik yazıyordu (468px / 448px) ve 390px'lik ekranda
 * 74-109px taşıyorlardı. Sabit genişlik masaüstünde doğru bir tercih —
 * tek sütunlu bir form ekranın tamamına yayılmamalı — eksik olan tek şey
 * max-width: 100% idi.
 */
export const FormPanel = styled.form<{ $width?: number; $gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.$gap ?? 24}px;
  width: ${(p) => p.$width ?? 468}px;
  max-width: 100%;
`;

export default FormRow;
